import { Typography, withStyles, withTheme } from '@material-ui/core';
import PropTypes from 'prop-types';
import React from 'react';
import { Box } from 'react-layout-components';
import { withRouter } from 'react-router-dom';
import FadeFromDown from '../transitions/FadeFromDown';
import Button from './Button';
import HoverableCard from './HoverableCard';
import Spacing from './Spacing';

class HomeCard extends React.PureComponent {

    constructor(props) {
        super(props)

        this.childId = HomeCard.ChildCount
    }

    getNextDelay = () => {
        return (this.props.index || 0) * 400
    }

    render() {

        const { classes, theme, title, description, image, visible, link, history } = this.props
        return (
            <FadeFromDown visible={visible} delay={this.getNextDelay()}>
                <HoverableCard>
                    <Box column center>
                        {
                            image && (
                                <img alt={title} className={classes.sectionCardIcon} src={image} />
                            )
                        }

                        <Typography variant={'title'} color={'primary'}
                                    style={{
                                        color: theme.palette.primary.main,
                                        fontWeight: '700',
                                        fontFamily: 'Montserrat',
                                        textAlign: 'center'
                                    }}>
                            {title}
                        </Typography>
                        
                        <Spacing vertical/>
                        
                        <Typography variant={'body1'} align={'center'}
                                    style={{
                                        color: theme.palette.grey['700'],
                                        fontWeight: '400',
                                        fontFamily: 'Montserrat',
                                        textAlign: 'center'
                                    }}>
                            {description}
                        </Typography>
                        
                        <Spacing vertical/>

                        {
                            false && (
                                <Button
                            onClick={() => history.push(link)}
                            variant={'contained'}
                            color={'secondary'}
                            elevated>
                            Saiba Mais
                        </Button>
                                )
                        }
                        
                    </Box>
                </HoverableCard>
            </FadeFromDown>
        )
    }

}

HomeCard.propTypes = {
    classes: PropTypes.any,
    title: PropTypes.string,
    description: PropTypes.string,
    image: PropTypes.string,
    visible: PropTypes.bool,
    index: PropTypes.number
}

const styles = theme => ({
    sectionCardIcon: {
        height: 300,
        width: 'auto',
        marginBottom: 16
    }
})

export default withTheme()(withRouter(withStyles(styles)(HomeCard)))


// WEBPACK FOOTER //
// ./src/components/common/HomeCard.js